<template>
  <div v-if="!!phaseData && mounted">
    <v-expansion-panels flat class="mt-2" multiple v-model="panel" active-class="active-border">
      <v-expansion-panel class="mb-4 panel-border">
        <v-expansion-panel-header class="text-subtitle-1 font-weight-medium">Pessoal</v-expansion-panel-header>
        <v-expansion-panel-content>
          <div v-for="option in personalOptions" :key="option.key">
            <radio-options
              :label="option.name"
              v-model="phaseData.profile[option.key].value"
              row
              clearable
              :options="option.options || defaultProfileOptions"
              @change="checkProfile(option.key, $event)"
              :disabled="option.disabled && option.disabled(attendance.disease.id)"
              :subtitle="getSubtitle(option.disabled && option.disabled(attendance.disease.id))"
              :rules="option?.required ? [$validation.radioRequired()] : []"
              :required="option.required"
            />
            <div
              v-if="
                phaseData?.profile[option.key]?.value &&
                phaseData?.profile[option.key]?.value !== 'NÃO' &&
                option?.key === 'tuberculose'
              "
              class="ml-3"
            >
              <v-row>
                <div class="col-sm-5 col-md-12 col-lg-5 col">
                  <v-menu
                    ref="pickTuberculoseDate"
                    v-model="pickTuberculoseDate"
                    :close-on-content-click="false"
                    transition="scale-transition"
                    offset-y
                    max-width="290px"
                    min-width="auto"
                    :required="option.required"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        :value="
                          phaseData.diseases_info.neoplasia.end
                            ? $moment(phaseData.diseases_info.neoplasia.end).format('DD/MM/YYYY')
                            : ''
                        "
                        outlined
                        label="Data do diagnóstico"
                        append-icon="mdi-calendar"
                        v-bind="attrs"
                        v-on="on"
                      />
                    </template>
                    <v-date-picker
                      v-model="phaseData.diseases_info.neoplasia.end"
                      no-title
                      @change="pickTuberculoseDate = false"
                      locale="pt-br"
                    ></v-date-picker>
                  </v-menu>
                </div>
              </v-row>
            </div>
            <div v-if="phaseData?.profile[option.key]?.value === true && option?.key === 'contracepcao'" class="ml-3">
              <v-row>
                <v-col cols="6" class="mt-3 py-0 pb-3">
                  <div
                    v-for="contracepcaoOption in contracepcaoOptions"
                    :key="contracepcaoOption.key"
                    class="d-flex flex-column"
                  >
                    <v-checkbox
                      :label="contracepcaoOption.name"
                      :value="contracepcaoOption.key"
                      v-model="phaseData.profile_info.contracepcao.selected"
                      hide-details
                      dense
                    />
                  </div>
                </v-col>
              </v-row>
            </div>
          </div>

          <field-label label="Caso tenha doença crônica ou prévia importante, selecione quais">
            <v-autocomplete
              label="Selecionar doenças"
              outlined
              placeholder="Selecionar doenças"
              item-value="id"
              item-text="name"
              multiple
              chips
              small-chips
              deletable-chips
              v-model="phaseData.diseases"
              :items="diseaseOptions"
            ></v-autocomplete>
          </field-label>

          <text-area
            v-if="phaseData.diseases.some((d) => d === 'Outras comorbidades')"
            label="Outras comorbidades?"
            v-model="phaseData.otherComorbidities"
            :max-length="500"
            :rows="2"
          />

          <text-area label="Quais medicamentos usa?" v-model="phaseData.medicine" :max-length="500" :rows="2" />
        </v-expansion-panel-content>
      </v-expansion-panel>

      <v-expansion-panel class="mb-4 panel-border">
        <v-expansion-panel-header class="text-subtitle-1 font-weight-medium">Familiar</v-expansion-panel-header>
        <v-expansion-panel-content>
          <div v-for="familyOption in familyOptions" :key="familyOption.key">
            <radio-options
              :key="familyOption.key"
              :label="familyOption.name"
              v-model="phaseData.familyAtopias[familyOption.key].value"
              row
              hide-details
              :options="defaultProfileOptions"
              @change="resetObject(familyOption.key)"
              :rules="familyOption.required ? [$validation.radioRequired()] : []"
              :required="familyOption.required"
            />

            <field-label
              :label="'Grau de parentesco:'"
              :key="familyOption.key + '_degree_wrapper'"
              class="mt-3"
              v-if="phaseData.familyAtopias[familyOption.key].value"
              :required="familyOption.required"
            >
              <div class="d-flex ml-3">
                <div
                  v-for="degree in familyOption.degrees"
                  :key="familyOption.key + '_' + degree + 'grau'"
                  class="mr-3"
                >
                  <v-checkbox
                    dense
                    :label="degree + ' Grau'"
                    :value="degree"
                    v-model="phaseData.familyAtopias[familyOption.key].degree"
                  />
                </div>
              </div>
            </field-label>
          </div>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
    <attendance-step-note class="mt-8 py-2" />
  </div>
</template>
<script>
import { createNamespacedHelpers } from 'vuex'

import {
  CONTRACEPCAO,
  PERSONAL_HISTORY_CHRONIC_DISEASES_OPTIONS,
  PERSONAL_HISTORY_HABITS_OPTIONS,
  PERSONAL_HISTORY_OBSTETRIC_OPTIONS,
  PERSONAL_HISTORY_PROFILE_OPTIONS,
} from '@/components/AttendanceForm/general/constants/personalHistory'
import FieldLabel from '@/components/FieldLabel.vue'
import RadioOptions from '@/components/RadioOptions.vue'
import TextArea from '@/components/TextArea.vue'
import { DISEASES } from '@/constants/disease'
import BasePhase from '../../../general/phase/BasePhase.vue'
import {
  FAMILY_HISTORY_OPTIONS,
  PERSONAL_HISTORY_FEMALE_OPTIONS,
  PERSONAL_HISTORY_OPTIONS,
  COMORBIDITIES_OPTIONS,
} from '@/components/AttendanceForm/general/constants/medicalHistory'
import AttendanceStepNote from '@/components/AttendanceForm/psoriasis/phase/v2/AttendanceStepNote.vue'

const { mapGetters: attendanceGettersMap } = createNamespacedHelpers('attendance')

export default {
  components: { AttendanceStepNote, FieldLabel, TextArea, RadioOptions },
  extends: BasePhase,
  computed: {
    ...attendanceGettersMap(['getPhaseDataByKey', 'attendance', 'attendanceDiseaseId']),
    personalOptions() {
      const options = PERSONAL_HISTORY_OPTIONS
      if (this.attendance.patient.assignedSex === 'F') {
        return options.concat(PERSONAL_HISTORY_FEMALE_OPTIONS)
      }
      return options
    },
    diseaseOptions() {
      return COMORBIDITIES_OPTIONS.sort(function (a, b) {
        if (a.key === 'outras_comorbidades') return 1
        if (a.name < b.name) return -1
        if (a.name > b.name) return 1
        return 0
      })
    },
    defaultProfileOptions() {
      return [
        { text: 'Sim', value: true },
        { text: 'Não', value: false },
      ]
    },
    symptomsPhaseData() {
      return this.getPhaseDataByKey('sintomas')
    },
  },
  data() {
    return {
      pickTuberculoseDate: false,
      pickStartDate: false,
      pickEndDate: false,
      mounted: false,
      habitsOptions: PERSONAL_HISTORY_HABITS_OPTIONS,
      obstetricOptions: PERSONAL_HISTORY_OBSTETRIC_OPTIONS,
      chronicDiseaseOptions: PERSONAL_HISTORY_CHRONIC_DISEASES_OPTIONS,
      familyOptions: FAMILY_HISTORY_OPTIONS,
      contracepcaoOptions: CONTRACEPCAO,
      disease: DISEASES,
      panel: [],
    }
  },
  methods: {
    getDefaultData() {
      return {
        noDisease: false,
        otherDisease: null,
        diseases: this.buildDiseasesArray(),
        diseases_info: this.buildDiseaseInfo(),
        medicine: null,
        profile: this.buildEmptyProfile(),
        familyAtopias: this.buildFamilyAtopia(),
        profile_info: this.buildProfileInfo(),
        notes: null,
      }
    },
    buildDiseasesArray() {
      return this.symptomsPhaseData?.symptoms?.alteracao_habito_intestinal?.value
        ? ['doenca_inflamatoria_intestinal']
        : []
    },
    buildDiseaseInfo() {
      return {
        hepatite_b: {
          viral_load: null,
        },
        hepatite_c: {
          viral_load: null,
        },
        hiv: {
          viral_load: null,
          cd4: null,
        },
        dermatite_contato: {
          sensibility: null,
        },
        alergias: {
          selected: [],
          description: null,
        },
        neoplasia: {
          treatment: null,
          start: null,
          end: null,
        },
        herpes_simples: {
          times_per_year: null,
        },
        erupcao_variceliforme_kaposi: {
          times: null,
        },
      }
    },
    buildEmptyProfile() {
      return [
        ...PERSONAL_HISTORY_PROFILE_OPTIONS,
        ...PERSONAL_HISTORY_CHRONIC_DISEASES_OPTIONS,
        ...PERSONAL_HISTORY_HABITS_OPTIONS,
        ...PERSONAL_HISTORY_OBSTETRIC_OPTIONS,
      ].reduce((acc, option) => {
        let value = null

        if (option.key === 'uveite') {
          value = this.symptomsPhaseData?.symptoms?.uveite?.value
        }
        if (option.key === 'diarreia_cronica') {
          value = this.symptomsPhaseData?.symptoms?.alteracao_habito_intestinal?.value
        }

        return { ...acc, [option.key]: { value } }
      }, {})
    },
    buildFamilyAtopia() {
      return {
        esclerose_multipla: {
          value: null,
          degree: [],
        },
        psoriase: {
          value: null,
          degree: [],
        },
      }
    },
    buildProfileInfo() {
      return {
        tuberculose: {
          diagnosis: null,
          treatment: {
            year: null,
            months: null,
            treatments: [],
            other: null,
          },
        },
        menarca: {
          age: null,
        },
        contracepcao: {
          selected: [],
          other: null,
        },
      }
    },
    checkProfile(key, value) {
      if (key === 'cancer_pele' && !value) {
        this.phaseData.profile['tipo_cancer_pele'].value = null
      }
    },
    getSubtitle(showSub) {
      if (!showSub) {
        return null
      }
      return 'Essa opção já foi preenchida em Anamnese - Sintomas'
    },
    resetObject(key) {
      if (!this.phaseData.diseases.includes(key)) {
        for (let param in this.phaseData.diseases_info[key]) {
          Array.isArray(this.phaseData.diseases_info[key][param])
            ? (this.phaseData.diseases_info[key][param] = [])
            : (this.phaseData.diseases_info[key][param] = null)
        }
      }
      if (!this.phaseData.familyAtopias[key].selected) {
        this.phaseData.familyAtopias[key].degree = []
      }
    },
  },
  mounted() {
    const keys = ['tratou_tuberculose', 'tuberculose', 'etilista', 'tabagista']
    keys.forEach((key) => {
      if (typeof this.phaseData.profile[key]?.value == 'boolean') {
        this.phaseData.profile[key].value = this.phaseData.profile[key].value ? 'SIM' : 'NÃO'
      }
    })

    if (!this.phaseData.diseases_info) this.phaseData.diseases_info = this.buildDiseaseInfo()
    if (!this.phaseData.profile_info) this.phaseData.profile_info = this.buildProfileInfo()
    this.phaseData.profile = { ...this.buildEmptyProfile(), ...this.phaseData.profile }
    this.phaseData.familyAtopias = { ...this.buildFamilyAtopia(), ...this.phaseData.familyAtopias }
    this.mounted = true
    if (this.attendance.status === 'F') {
      this.panel = [0, 1]
    }
  },
}
</script>

<style scoped>
.disease-checkbox {
  padding: 12px;
  margin: 8px;
  height: 100%;
  align-content: center;
  border-radius: 10px;
}

.selected-checkbox {
  border: 2px solid #1976d2;
}

.disease-checkbox-wrapper {
  margin: 12px;
  padding: 12px;
  border: 2px solid #33333330;
  height: 100%;
  align-content: center;
  border-radius: 10px;
}

:deep(.v-input--selection-controls.v-input) {
  align-items: center;
}

:deep(.v-application--is-ltr .v-input--selection-controls__input) {
  align-self: flex-start;
}

.panel-border {
  border: 1px solid #e6e6e6;
  border-radius: 4px;
}

.active-border {
  border: 2px solid #1976d2;
  transition: none !important;
}
</style>
